// extracted by mini-css-extract-plugin
export var active = "paging-module--active--ae35c";
export var pagination = "paging-module--pagination--90452";
export var paginationLabel = "paging-module--pagination-label--096cd";
export var paginationWrapper = "paging-module--pagination-wrapper--fb3b5";